'use strict';

/**
 * @ngdoc function
 *
 * @name wd.deployment.service:wdDeploymentService
 *
 * @description
 * # deployment
 * Deployment Service
 *
 * @version 12.4.0 #756 MLIBJS-121 Add validation to export wdDeploymentService for ES6 usage
 *          0.7.0
 * @author Deitric Jang <djang@webduct.com>
 * @author Ryan Sweeney <rsweeney@webduct.com>
 * @author Erik Orozco <eorozco@intersog.com>
 * @copyright (c) 2014-2020 Build Centrix
 */
var wdDeploymentService = angular.module('wd.deployment', [])
    .factory(
    'wdDeploymentService',
    [
        'wdOauth2HttpService',
        function (wdOauth2HttpService)
        {
            var service = {};

            /**
             * Replace a placeholder string in a url with the deployment token.
             *
             * @since 1.1.0
             *
             * @param {String} url
             * @returns {String}
             */
            service.replaceDeploymentTokenInUrl = function (url)
            {
                var targetString = 'DEPLOYMENT_TOKEN';  // the placeholder string to replace
                var deploymentToken;
                var result;

                deploymentToken = wdOauth2HttpService.getDeploymentToken(); // get the deployment token

                // Check for multiple deployment tokens
                var separatorIndex = deploymentToken.indexOf('+');                    // spaces are coming through as plus character
                if (separatorIndex !== -1) {                                          // found multiple deployments
                    deploymentToken = deploymentToken.substring(0, separatorIndex);   // use first deployment token
                }

                result = url.replace(targetString, deploymentToken);    // replace the placeholder with the deployment token

                return result;
            };

            return service;
        }
    ]
);
if (typeof module !== 'undefined' && module.exports) {
    module.exports = wdDeploymentService;
}
// EOF
